import React from 'react';
import { Award, Target, Heart } from 'lucide-react';

const About = () => {
  const values = [
    {
      icon: Heart,
      title: 'Honestidad y Confianza',
      description: 'Construimos relaciones duraderas basadas en la transparencia y el compromiso con nuestros clientes.'
    },
    {
      icon: Target,
      title: 'Atención Personalizada',
      description: 'Cada proyecto recibe un tratamiento único, adaptado a las necesidades específicas de nuestros clientes.'
    },
    {
      icon: Award,
      title: 'Responsabilidad',
      description: 'Cumplimiento en tiempo y forma con los más altos estándares de calidad de la industria.'
    }
  ];

  return (
    <section id="nosotros" className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div>
            <h2 className="text-3xl sm:text-4xl font-bold text-brand mb-6">
              Sobre Andes Metal - Empresa Metalmecánica en Mendoza
            </h2>
            <div className="space-y-6 text-gray-700 leading-relaxed">
              <p className="text-lg">
                <span className="font-semibold text-brand">Andes Metal</span> se inició en 2015, incorporando la experiencia de 3 décadas de su socio fundador, creciendo sin interrupciones y desarrollando servicios y calidad propia hasta la fecha.
              </p>
              <p>
                Nuestra misión es prestar atención personalizada y brindar un servicio competitivo y de rápida respuesta con los estándares de calidad de empresas mayores.
              </p>
              <p>
                Nos especializamos en el sector metalmecánico, atendiendo a fábricas de transformadores eléctricos, empresas en general y centrales hidroeléctricas en toda la región de Mendoza.
              </p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-4 sm:gap-6 mt-10">
              <div className="text-center">
                <div className="text-2xl sm:text-3xl font-bold text-brand">2015</div>
                <div className="text-xs sm:text-sm text-gray-600 mt-1">Fundación</div>
              </div>
              <div className="text-center">
                <div className="text-2xl sm:text-3xl font-bold text-brand">30+</div>
                <div className="text-xs sm:text-sm text-gray-600 mt-1">Años Experiencia</div>
              </div>
              <div className="text-center">
                <div className="text-2xl sm:text-3xl font-bold text-brand">100%</div>
                <div className="text-xs sm:text-sm text-gray-600 mt-1">Compromiso</div>
              </div>
            </div>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="relative h-[400px] sm:h-[500px] rounded-lg overflow-hidden shadow-xl">
              <img
                src="/images/about-work.jpg"
                alt="Trabajo en Andes Metal"
                className="w-full h-full object-cover"
                style={{ objectPosition: 'center 60%' }}
              />
            </div>
          </div>
        </div>

        {/* Values Section */}
        <div className="mt-20">
          <h3 className="text-xl sm:text-2xl lg:text-3xl font-bold text-brand text-center mb-12">
            Nuestros Valores
          </h3>
          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8">
            {values.map((value, index) => {
              const Icon = value.icon;
              return (
                <div
                  key={index}
                  className="bg-gray-50 p-8 rounded-lg text-center hover:shadow-lg transition-shadow duration-300"
                >
                  <div className="inline-flex items-center justify-center w-16 h-16 bg-brand rounded-full mb-6">
                    <Icon className="w-8 h-8 text-white" />
                  </div>
                  <h4 className="text-xl font-semibold text-brand mb-3">
                    {value.title}
                  </h4>
                  <p className="text-gray-600 leading-relaxed">
                    {value.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
